module.exports = __webpack_public_path__ + "static/media/C-Employment.a149d1ca.png";